import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import styled from "styled-components";
import InfoPart from "../../../molecules/info/InfoPart/InfoPart";
import Usp from "../../../atoms/Usp/Usp";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import forester from "./../../../../assets/info/forester-hero.jpg";
import fit1 from "./../../../../assets/info/subaru-forester/levelling-fig-1.jpg";
import fit2 from "./../../../../assets/info/subaru-forester/levelling-fig-2.jpg";
import fit3 from "./../../../../assets/info/subaru-forester/levelling-fig-3.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const SubaruForester = () => {
  useSmallNav("Subaru Forester");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru Forester"} bolder />
        <InfoHero image={forester} />
        <Section>
          <InfoPart
            header={"1997-2002 SF 'EziFit' Rear Conversion Kit"}
            link={"803037"}
            photoUrl={"https://3cerp.eu/api/file/803037_4.jpg"}
            catalogue={
              "?make=Subaru&model=Forester&peryear=1997&variant=SF+Model"
            }
          >
            <Usp>Cost effective Alternative to Original Self Levelling</Usp>
            <Usp>Fits all Forester SG series models inc Turbo</Usp>
            <Usp>Bolt on EziFit saving you more money in garage fees</Usp>
            <Usp>We will ship anywhere within Europe</Usp>
          </InfoPart>
          <InfoPart
            header={"2002-2008 SG 'EziFit' Rear Conversion Kit"}
            link={"803040"}
            photoUrl={"https://3cerp.eu/api/file/803040_4.jpg"}
            catalogue={
              "?make=Subaru&model=Forester&peryear=2002&variant=SG+Model"
            }
          >
            <Usp>Cost effective Alternative to Original Self Levelling</Usp>
            <Usp>Fits all Forester SG series models inc Turbo</Usp>
            <Usp>Bolt on EziFit saving you more money in garage fees</Usp>
            <Usp>We will ship anywhere within Europe</Usp>
          </InfoPart>
          <InfoPart
            header={"2008-2013 SH 'EziFit' Rear Conversion Kit"}
            link={"803043"}
            photoUrl={"https://3cerp.eu/api/file/803043_4.jpg"}
            catalogue={
              "?make=Subaru&model=Forester&peryear=2008&variant=SH+Model"
            }
          >
            <Usp>Cost effective Alternative to Original Self Levelling</Usp>
            <Usp>Fits all Forester SG series models inc Turbo</Usp>
            <Usp>Bolt on EziFit saving you more money in garage fees</Usp>
            <Usp>We will ship anywhere within Europe</Usp>
          </InfoPart>
          <InfoPart
            header={"2013-On SJ models EziFit Strut"}
            link={"803043"}
            photoUrl={"https://pedders.co.uk/media/wysiwyg/sub-for-top.jpg"}
            catalogue={
              "?make=Subaru&model=Forester&peryear=2008&variant=SH+Model"
            }
          >
            <Usp>Cost effective Alternative to Original Self Levelling</Usp>
            <Usp>Fits all Forester SG series models inc Turbo</Usp>
            <Usp>Bolt on EziFit saving you more money in garage fees</Usp>
            <Usp>We will ship anywhere within Europe</Usp>
          </InfoPart>
        </Section>
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Had a quote for new self levelling Subaru Forester Suspension?"
              }
            />
            <p>
              If you have had a quote you will know that these are very
              expensive! Pedders Suspension have the cost effective solution to
              your problems. We offer a replacement spring and damper kit for
              the rear of your Forester that will eliminate the troublesome self
              levelling arrangement. This is achieved by installing a
              conventional style rear shock and spring designed for this
              application.
            </p>
            <p>
              This kit is a direct bolt in replacement. NO modifications to the
              vehicle are required. No extra parts are required. When fitting
              you will of course need to re-use the original top mount
              arrangement. Spring compressors will be required to complete this
              task.
            </p>
            <p>
              Will my vehicle really be returned to its original Ride height?
              Yes, definitely! There are numerous examples of Foresters having
              had the Self-Levellers replaced with conventional dampers which
              then sit to low. This is because the original spring is too weak
              to support the full weight of the car as it is normally assisted
              in this task by the self levelling damper.
            </p>
            <p>
              Pedders Suspension overcome this be supplying a matched set of
              dampers and springs specifically for this purpose. You can buy
              with full confidence that the vehicle will be the correct height
              and your troublesome and expensive self levelling dampers
              consigned to history.
            </p>
            <iframe
              title={"Subaru Forester Video 1"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Subaru Forester Video 2"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            <InfoHeader smaller text={"Pedders 'EziFit' Struts & Springs"} />
            <p>
              Here at Pedders Suspension, we are always looking to give more to
              our customers. We are now proud to present our latest offering for
              the Subaru Forester. Ezi Fit Struts!
            </p>
            <p>
              Rather than purchasing separate springs, dampers, bump stops and
              then having to pay a technician to dis-assemble and re-assemble
              the parts for you, you can now buy the complete strut and just
              bolt it on yourself! Currently, these struts are only available
              for the Forester SG rear suspension at standard height.
            </p>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "Forester")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <div>
          <InfoHeader
            size="smaller"
            margin
            text={"Not sure if you have self levelling fitted?"}
            centered
          />
          <Fitted>
            <div>
              <img
                src={fit1}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Some earlier SF shocks are blue/green. These are easy to
                identify. Later ones can be painted black. On these, it is only
                possible to tell by part number. The obvious giveaway of course
                is if the vehicle is sitting lower than normal and the springs
                look OK.
              </p>
            </div>
            <div>
              <img
                src={fit2}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Forester SG- This is fairly easy to confirm. Vehicles with self
                levelling have a canister attached to the side of the
                damper/shock as shown in the picture below. If there is no
                canister fitted and it looks the same as our Pedders shocks,
                then it does not have self levelling.
              </p>
            </div>
            <div>
              <img
                src={fit3}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Forester SH models have a "bulge" at the bottom of the standard
                shock absorber.
              </p>
            </div>
            <div>
              <img
                src={fit3}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Forester SJ models have a "bulge" at the bottom of the standard
                shock absorber.
              </p>
            </div>
          </Fitted>
        </div>
        <div>
          <InfoHeader
            text={"Not sure which version of Forester you have?"}
            centered
            margin
            size="smaller"
          />
          <p>
            The simplest way to check is to look at the VIN number. This is
            located in the bottom right hand corner of the windscreen as you
            stand in front of the vehicle. The 4th and 5th digits will be either
            SF, SG or SH. Once you know this, then you can simply select from
            the menus below.
          </p>
        </div>
        <InfoFooter make="Subaru" model="Forester" />
      </Container>
    </section>
  );
};

export default SubaruForester;

const Section = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;
  @media (min-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
    column-gap: 30px;
  }
`;

const Fitted = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  img {
    width: auto;
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;

    img {
      width: auto;
      margin-bottom: 20px;
      max-height: 200px;
    }
  }
`;
